import { render } from "./ShareholderDetails.vue?vue&type=template&id=7bdb2433&scoped=true"
import script from "./ShareholderDetails.vue?vue&type=script&lang=js"
export * from "./ShareholderDetails.vue?vue&type=script&lang=js"

import "./ShareholderDetails.vue?vue&type=style&index=0&id=7bdb2433&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bdb2433"]])

export default __exports__